import { format } from "date-fns";

import { BatteryState } from "types/store";
import moment from "moment";
import {BATTERY_STATUS} from "../mapped-data";
import {FULL_DATE_FORMAT, TIME_FORMAT} from "../constants";
import {date} from "yup";
import { formatDate } from "./date-parser";

export function parseBatteryTable(
    search: BatteryState["search"],
    list?: BatteryState["batteries"],
    listType?: BatteryState["filters"]["listType"]
) {
    if (list) {
        const data = list.map((battery, index) => ({
            key: index,
            battery_id: battery.batteryId,
            battery_alias: battery.batteryAlias,
            soc_level: !isNaN(parseFloat(battery.socLevel))
                ? `${parseFloat(battery.socLevel)}%`
                : "-",

            soh_level:  battery.batterySoh ?? '-',
            battery_health: battery.batteryHealth,
            operational_state: battery.operationalState || "-",
            make_model: battery.make_model,
            battery_: battery.batteryAlias,
            host_id: battery.hostId != "00000000-0000-0000-0000-000000000000" ? battery.hostId || "-" : "-",
            status: BATTERY_STATUS[battery.status] || "Operational",
            updated_at: formatDate(battery.updatedAt),
            action: "",
            raw: battery,
            listType: listType,
        }));
        return data
    }

    return [];
}

export function parseBatteryDetailTable(
    list?: BatteryState["batteryDetail"]
){
    console.log("list in battery detail parse", list);
    /**
     * {
     *         time: new Date().toString(),
     *         charging_counter: "30V",
     *         voltage: "1A",
     *         current: "40.5%",
     *         soc: "33%",
     *         temperature: "30°C",
     *         cycles: "5H3.30V",
     *         heartbeat: "2L3.31V NC:20 NT:1",
     *         mosfet_charging: "30V",
     *         mosfet_discharging: "30V",
     *         individual_cell_voltages: "13V",
     *     },
     */
    if(list) {
        const data = list.map((batteryHB, index) => ({
            key: index,
            created_at: moment().format('YYYY-MM-DD hh:mm:s a').toString(),
            charging_counter: batteryHB.chargerCounter,
            voltage: batteryHB.batteryVoltage,
            current: batteryHB.current,
            soc: batteryHB.batterySoc,
            temperature: batteryHB.batteryTemperature,
            cycles: batteryHB.numberOfCycles,
            heartbeat: "-",
            mosfet_charging: batteryHB.chargeMofsetState,
            mosfet_discharging: batteryHB.dischargeMofsetState,
            individual_cell_voltages: "-",
        }));

        return data
    }
    return [];
}

export function parseBatteryHeartbeatTable(
    list?: BatteryState["battery_heartbeat"]
){
    console.log("list in battery heartbeat parse", list);

    return [];
}



